/**
 * Created by dimah on 09/08/17.
 */

import { AbstractUserDTO } from "./user-abstract";

export class GuestUserDTO extends AbstractUserDTO {

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes || {};

        this.entity_type = "guest";
        this.type = "guest";
    }

    isGuest(): boolean {
        return true;
    }

}
